import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import ViewStoreProductLoading from './ViewStoreProductLoading';
import ProductDetails from './ProductDetails';
import useLang from "../../../hooks/useLang";
import { getProductFullDetails, addItemToCart } from './../../../apis/requests';
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import OptionsField from "../../widgets/fields/OptionsField";
import TextInputField from '../../widgets/fields/TextInputField';
import { Toast } from 'primereact/toast';
import store from "../../redux/store";
import { setCartCount } from "../../redux/reducer";
import ProductVariations from './ProductVariations';
import ProductMedia from './ProductMedia';
import ProductReviews from './ProductReviews';
const ViewStoreProduct = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const lang = useLang();
    const toast = useRef();
    const [product, setProduct] = useState(location.state);
    const [productFields, setProductFields] = useState([]);
    const [cartItem, setCartItem] = useState();
    const [prodQuantity, setProdQuantity] = useState(1);
    const [loading, setLoading] = useState(false);
    const [defaultVar, setDefaultVar] = useState();

    useEffect(() => {
        loadGetProductFullDetails();
    }, []);
    const loadGetProductFullDetails = async () => {
        try {
            let data = {
                sku: params.sku,
            }
            const res = await getProductFullDetails(data);
            setProduct(res.data.product.details);
            setProductFields(res.data.product.productFields);
            setCartItem({
                id: res.data.product.details.id,
                fields: {

                }
            });
        } catch (error) {
            console.log(error);

        }
    }
    const handleAddItemToCart = async () => {
        try {
            const check = checkMandatoryProductFields();
            if (!check) {
                toast.current.show({ severity: 'warn', summary: t('oops'), detail: t('enter_prod_fields'), life: 3000 });
            } else {
                setLoading(true);
                let guestCartId = localStorage.getItem('cart') === null ? crypto.randomUUID() : localStorage.getItem('cart');
                let data = {
                    cart_id: guestCartId,
                    product: cartItem,
                    quantity: prodQuantity,
                    type: product.type,
                    variation: product.default_variation,
                }
                const res = await addItemToCart(data);
                localStorage.setItem('cart', guestCartId);
                store.dispatch(setCartCount(res.data.cart_count))
                toast.current.show({ severity: 'success', detail: t('item_added_to_cart'), life: 3000 });
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    const checkMandatoryProductFields = () => {
        try {
            let mandatoryFields = productFields.filter((f) => f.is_mandatory === 1);
            return mandatoryFields.every((f) => cartItem.fields.hasOwnProperty(f.name));
        } catch (error) {
            console.log(error);
            return false;
        }
    }
    return (
        <div
            className="p-4 lg:p-10 md:p-5"
        >

            <Toast ref={toast}
                position="bottom-center"
            />
            {
                product === null &&
                <ViewStoreProductLoading />
            }
            {
                product !== null &&
                <div className="">

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-2 store-prod-view">
                        <div className="lg:col-span-5">
                            <ProductMedia product={product} />
                        </div>
                        <div className="lg:col-span-7">
                            <div className="lg:px-8">
                                <ProductDetails product={product} defaultVar={defaultVar} />
                                <div className="prod-add-to-cart-form">
                                    <div className='lg:px-4 px-2 lg:mx-4 mx-2'>
                                        <div>
                                            {
                                                productFields.map((f) => {
                                                    return (
                                                        <div key={f.id}>
                                                            {
                                                                f.field_type === "options" &&
                                                                <OptionsField
                                                                    options={f}
                                                                    onChange={(e) => {
                                                                        let item = cartItem;
                                                                        item.fields[f.name] = {
                                                                            en: f.name,
                                                                            ar: f.name_ar,
                                                                            value: e.value,
                                                                        };
                                                                        setCartItem(item);
                                                                    }}
                                                                />
                                                            }
                                                            {
                                                                f.field_type === "text_input" &&
                                                                <TextInputField
                                                                    options={f}
                                                                    onChange={(e) => {
                                                                        let item = cartItem;
                                                                        item.fields[f.name] = {
                                                                            en: f.name,
                                                                            ar: f.name_ar,
                                                                            value: e,
                                                                        };
                                                                        setCartItem(item);
                                                                    }}
                                                                />
                                                            }
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                        <div className="mb-4">
                                            <div className="flex items-center flex-wrap gap-2">
                                                <div className="mx-1">
                                                    <Button rounded outlined severity="secondary"
                                                        onClick={() => {
                                                            if (prodQuantity > 1) {
                                                                let item = cartItem;
                                                                item.quantity = prodQuantity - 1;
                                                                setProdQuantity(prodQuantity - 1);
                                                                setCartItem(item)
                                                            }
                                                        }}
                                                        style={{
                                                            height: 30,
                                                            width: 30
                                                        }}
                                                        icon={<span className="material-symbols-outlined">
                                                            remove
                                                        </span>}
                                                    />
                                                </div>
                                                <div className="w-20">
                                                    <InputNumber className="prod-view-checkout-qun-input"
                                                        style={{
                                                            borderRadius: 30
                                                        }}
                                                        readOnly
                                                        disabled
                                                        value={prodQuantity}
                                                    />
                                                </div>
                                                <div className="mx-1">
                                                    <Button rounded outlined severity="secondary"
                                                        onClick={() => {
                                                            if (product.stock_item === 1) {
                                                                if (prodQuantity < product.stock) {
                                                                    let item = cartItem;
                                                                    item.quantity = prodQuantity + 1;
                                                                    setProdQuantity(prodQuantity + 1);
                                                                    setCartItem(item)
                                                                }
                                                            } else {
                                                                let item = cartItem;
                                                                item.quantity = prodQuantity + 1;
                                                                setProdQuantity(prodQuantity + 1);
                                                                setCartItem(item)
                                                            }
                                                        }}
                                                        style={{
                                                            height: 30,
                                                            width: 30
                                                        }}
                                                        icon={<span className="material-symbols-outlined">
                                                            add_2
                                                        </span>}
                                                    />
                                                </div>
                                                <div className="lg:mx-6 lg:mx-2 lg:w-auto w-100 mt-4 lg:mt-0">
                                                    <Button rounded label={t('add_to_cart')}
                                                        className="!w-full"
                                                        loading={loading}
                                                        onClick={() => {
                                                            handleAddItemToCart();
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {

                        (product !== null && product.type === "variable") &&
                        <div className="mt-4">
                            <ProductVariations
                                onLoad={(variation) => {
                                    setDefaultVar(variation);
                                }}
                                prod={{
                                    pid: product.id,
                                    vid: product.default_variation,
                                    name: lang === "en" ? product.name : 'w'
                                }}
                            />
                        </div>
                    }
                    <TabView>
                        <TabPanel header={t('description')}>
                            <div className="">
                                <div className="break-words whitespace-pre-wrap "
                                    dangerouslySetInnerHTML={{
                                        __html: product.description_ar,
                                    }}
                                >
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header={t('reviews')}>
                            <ProductReviews />
                        </TabPanel>
                    </TabView>
                </div>

            }


        </div>
    );
}
export default ViewStoreProduct;